[
  {
    "id": "ball",
    "stage": "baby",
    "player_level": 1,
    "tier": 1,
    "boost_type": "minigame-score",
    "encyclopedia_order": 101,
    "name_jp": "ぶるぶる科タマ属",
    "name_en": "tama",
    "description_jp": "常にぶるぶるしている。\n遊ぶのが好き。\n語尾は「コロ」。\n会話の得意分野は小さい頃の遊び。",
    "description_en": "Always shivering.\nLikes to play.\nFavorite area of conversation is childhood play.",
    "stomach_ini": 39,
    "love_ini": 41,
    "dirtiness_ini": 0,
    "urine_ini": 0,
    "tooth_acidity_ini": 0,
    "stomach_sec": 18,
    "love_sec": 24,
    "dirtiness_sec": 30,
    "urine_sec": 36,
    "tooth_acidity_sec": 72,
    "scared_coefficient": 3,
    "next_weights": {
      "crab": 100,
      "hamster": 100,
      "squirrel": 50
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "starball",
    "stage": "baby",
    "player_level": 1,
    "tier": 1,
    "boost_type": "bpoint",
    "encyclopedia_order": 102,
    "name_jp": "ぶるぶる科ホシタマ属",
    "name_en": "hoshitama",
    "description_jp": "常にぶるぶるしている。\n怖がりつつも、好奇心旺盛で寄ってくる。\n語尾は「スタ」。\n会話の得意分野は昔のお菓子。",
    "description_en": "Always shivering.\nScared, but curious and come close.\nFavorite area of conversation is old-time snacks.",
    "stomach_ini": 39,
    "love_ini": 41,
    "dirtiness_ini": 0,
    "urine_ini": 0,
    "tooth_acidity_ini": 0,
    "stomach_sec": 18,
    "love_sec": 24,
    "dirtiness_sec": 30,
    "urine_sec": 36,
    "tooth_acidity_sec": 72,
    "scared_coefficient": 3,
    "next_weights": {
      "turtle": 100,
      "fish": 100,
      "squirrel": 50
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "crab",
    "stage": "kid",
    "player_level": 1,
    "tier": 1,
    "boost_type": "minigame-score",
    "encyclopedia_order": 201,
    "name_jp": "ぶるぶる科カニ属",
    "name_en": "kani",
    "description_jp": "常にぶるぶるしている。\nすぐ話が横にそれる。\nハサミから泡を出して部屋を泡々に。\n語尾は「カニ」。\n会話の得意分野は健康。",
    "description_en": "Always shivering.\nEasly sidetracked.\nMakes the room foamy with the bubbles ouf of the shissors.\nFavorite area of conversation is health.",
    "stomach_sec": 66,
    "love_sec": 79,
    "dirtiness_sec": 120,
    "urine_sec": 144,
    "tooth_acidity_sec": 108,
    "scared_coefficient": 2,
    "next_weights": {
      "dog": 100,
      "pig": 100,
      "bear": 50
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "hamster",
    "stage": "kid",
    "player_level": 1,
    "tier": 1,
    "boost_type": "minigame-score",
    "encyclopedia_order": 202,
    "name_jp": "ぶるぶる科ハム属",
    "name_en": "hamu",
    "description_jp": "常にぶるぶるしている。\n穴が好きで、容器にするする入る。\n食べ物はあげても隠して食べないことも。\n語尾は「ハム」。\n会話の得意分野は加工食品。",
    "description_en": "Always shivering.\nLikes holes and slips into containers.\nSometimes hides food when you give to them.\nFavorite area of conversation is processed foods.",
    "stomach_sec": 66,
    "love_sec": 79,
    "dirtiness_sec": 120,
    "urine_sec": 144,
    "tooth_acidity_sec": 108,
    "scared_coefficient": 2,
    "next_weights": {
      "pig": 100,
      "bear": 100,
      "persiancat": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "turtle",
    "stage": "kid",
    "player_level": 1,
    "tier": 1,
    "boost_type": "bpoint",
    "encyclopedia_order": 203,
    "name_jp": "ぶるぶる科カメ属",
    "name_en": "kame",
    "description_jp": "常にぶるぶるしている。\nやや年寄り風で、突然川柳を読み出す。\n反応がゆっくりで、何事も遅い。\n語尾は「カメ」。\n会話の得意分野はスローライフ。",
    "description_en": "Always shivering.\nLikes what older people like and suddently starts reading willows.\nReacts slowly and everything is slow.\nFavorite area of conversation is slow living.",
    "stomach_sec": 66,
    "love_sec": 79,
    "dirtiness_sec": 120,
    "urine_sec": 144,
    "tooth_acidity_sec": 108,
    "scared_coefficient": 2,
    "next_weights": {
      "sealion": 100,
      "seaotter": 100,
      "cat": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "squirrel",
    "stage": "kid",
    "player_level": 1,
    "tier": 2,
    "boost_type": "bpoint",
    "encyclopedia_order": 210,
    "name_jp": "ぶるぶる科リス属",
    "name_en": "risu",
    "description_jp": "常にぶるぶるしている。\n小僧っぽい元気キャラ。\n筋トレとか体を動かすことが大好き。\n語尾は「ッス」",
    "description_en": "Always shivering.\nA boyish, energetic character.\nLoves muscle training and physical activity.",
    "stomach_sec": 66,
    "love_sec": 79,
    "dirtiness_sec": 120,
    "urine_sec": 144,
    "tooth_acidity_sec": 108,
    "scared_coefficient": 2,
    "next_weights": {
      "persiancat": 100,
      "sealion": 100,
      "seaotter": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 100
    }
  },
  {
    "id": "fish",
    "stage": "kid",
    "player_level": 1,
    "tier": 2,
    "boost_type": "minigame-score",
    "encyclopedia_order": 211,
    "name_jp": "ぶるぶる科ウオ属",
    "name_en": "uo",
    "description_jp": "常にぶるぶるしている。\n水に関するものが好き。\n液体の食べ物が好き。\n語尾は「ウオ」。",
    "description_en": "Always shivering.\nLikes things related to water.\nLikes liquid food.",
    "stomach_sec": 66,
    "love_sec": 79,
    "dirtiness_sec": 120,
    "urine_sec": 144,
    "tooth_acidity_sec": 108,
    "scared_coefficient": 2,
    "next_weights": {
      "cat": 100,
      "penguin": 100,
      "seaotter": 50
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "dog",
    "stage": "youth",
    "player_level": 1,
    "tier": 1,
    "boost_type": "minigame-score",
    "encyclopedia_order": 301,
    "name_jp": "ぶるぶる科イヌ属",
    "name_en": "inu",
    "description_jp": "常にぶるぶるしている。\n散歩が大好きで、よく動き回る。\n部屋をすぐに汚す。\n語尾は「ヌ」。\n会話の得意分野は天気のうんちく。",
    "description_en": "Always shivering.\nLikes to walk and moves around a lot.\nMakes the room dirty easily.\nFavorite area of conversation is trivia about weather.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "giraffe": 100,
      "panda": 100,
      "tiger": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "seaotter",
    "stage": "youth",
    "player_level": 1,
    "tier": 1,
    "boost_type": "bpoint",
    "encyclopedia_order": 302,
    "name_jp": "ぶるぶる科ラッコ属",
    "name_en": "rakko",
    "description_jp": "常にぶるぶるしている。\nだいたい横になっている。\n貝が好きだが、すぐに壊して泣く。\n語尾は「ッコ」。\n会話の得意分野は貝に関するうんちく。",
    "description_en": "Always shivering.\nUsually lying down.\nLikes shellfish, but breaks them easily and cries.\nFavorite area of conversation is trivia about shellfish.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "pinkdog": 100,
      "dinosaur": 100,
      "polarbear": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "cat",
    "stage": "youth",
    "player_level": 1,
    "tier": 1,
    "boost_type": "bpoint",
    "encyclopedia_order": 303,
    "name_jp": "ぶるぶる科ネコ属",
    "name_en": "neko",
    "description_jp": "常にぶるぶるしている。\n眠るのが大好き。\n話しているうちに寝てしまうことも。\n語尾は「ミャ」。\n会話の得意分野はネコに関するうんちく。",
    "description_en": "Always shivering.\nLoves to sleep.\nSometimes falls asleep while talking.\nFavorite area of conversation is trivia about cats.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "alpaca": 100,
      "polarbear": 100,
      "reindeer": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "bear",
    "stage": "youth",
    "player_level": 1,
    "tier": 2,
    "boost_type": "minigame-score",
    "encyclopedia_order": 307,
    "name_jp": "ぶるぶる科クマ属",
    "name_en": "kuma",
    "description_jp": "常にぶるぶるしている。\n四字熟語で会話するのが好き。\n失敗談をよく話して自分で落ち込む。\n語尾は「クマ」。\n会話の得意分野は四字熟語。",
    "description_en": "Always shivering.\nLikes to use four-kanji words.\nOften talks about own failures and get depressed.\nFavorite area of conversation is four-kanji idioms.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "lion": 100,
      "elephant": 100,
      "whale": 50
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "pig",
    "stage": "youth",
    "player_level": 1,
    "tier": 2,
    "boost_type": "minigame-score",
    "encyclopedia_order": 310,
    "name_jp": "ぶるぶる科ブタ属",
    "name_en": "buta",
    "description_jp": "常にぶるぶるしている。\n疑い深い。\n思い込みが激しく、勝手にいじけることも。\n語尾は「ブー」。\n会話の得意分野は心理学や心理テスト。",
    "description_en": "Always shivering.\nDoubting and assumptive.\nFavorite area of conversation is psychology and psychological testing.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "panda": 100,
      "whale": 100,
      "lion": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "penguin",
    "stage": "youth",
    "player_level": 1,
    "tier": 2,
    "boost_type": "bpoint",
    "encyclopedia_order": 311,
    "name_jp": "ぶるぶる科ペン属",
    "name_en": "pen",
    "description_jp": "常にぶるぶるしている。\n左右にぴこぴこ歩き続ける。\n寒がりで、マフラーや帽子を好む。\n語尾は「ペン」。\n会話の得意分野は雪や寒さ対策のうんちく。",
    "description_en": "Always shivering.\nKeeps walking while swaying side to side.\nWeak agianst cold weather and likes scarves and hats.\nFavorite area of conversation is trivia about cold weather.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "reindeer": 50,
      "alpaca": 50,
      "flamingo": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "whale",
    "stage": "adult",
    "player_level": 1,
    "tier": 1,
    "boost_type": "bpoint",
    "encyclopedia_order": 401,
    "name_jp": "ぶるぶる科クジラ属",
    "name_en": "kujira",
    "description_jp": "常にぶるぶるしている。\n部屋を水浸しにすることも。\nすぐに喉が渇く。乾燥しやすい\n語尾は「ラ」。\n会話の得意分野は海に関するうんちく。",
    "description_en": "Always shivering.\nSometimes floods the room.\nGets dry and thirsty easily.\nFavorite area of conversation is trivia about the ocean.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 200
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "giraffe",
    "stage": "adult",
    "player_level": 1,
    "tier": 1,
    "boost_type": "minigame-score",
    "encyclopedia_order": 402,
    "name_jp": "ぶるぶる科キリン属",
    "name_en": "kirin",
    "description_jp": "常にぶるぶるしている。\n首同様に、話が長い。\n長いので途中で何の話をしていたか忘れる。\n心配性。\n語尾は「リン」。\n会話の得意分野は防犯・自衛うんちく。",
    "description_en": "Always shivering.\nTalks long like the neck.\nSo long that sometimes forgets the topic.\nWorrier.\nFavorite area of conversation is trivia about crime prevention and self-defense.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 200
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "pinkdog",
    "stage": "adult",
    "player_level": 1,
    "tier": 1,
    "boost_type": "minigame-score",
    "encyclopedia_order": 403,
    "name_jp": "ぶるぶる科モコ属",
    "name_en": "mokoinu",
    "description_jp": "常にぶるぶるしている。\n夢見がちな天然ちゃん。\n会話の途中が英語になる。\n語尾は「モコ」。\n会話の得意分野は役立ち英会話フレーズ。",
    "description_en": "Always shivering.\nDreamy.\nSuddenly speaks English in the middle of conversations.\nFavorite area of conversation is useful English phrases.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "panda",
    "stage": "adult",
    "player_level": 1,
    "tier": 1,
    "boost_type": "bpoint",
    "encyclopedia_order": 404,
    "name_jp": "ぶるぶる科パンダ属",
    "name_en": "panda",
    "description_jp": "常にぶるぶるしている。\nよく転がる。\n褒めたり、甘えてくることが多い。\n会話というより独り言が多い。\n語尾は「パ」。\n会話の得意分野は音楽のうんちく。",
    "description_en": "Always shivering.\nRolls often.\nOften complements and pampers.\nFavorite area of conversation is trivia about music.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 200
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "dinosaur",
    "stage": "adult",
    "player_level": 1,
    "tier": 2,
    "boost_type": "bpoint",
    "encyclopedia_order": 405,
    "name_jp": "ぶるぶる科ザウルス属",
    "name_en": "zaurusu",
    "description_jp": "常にぶるぶるしている。\nものすごく臆病者。\n怒るとツノから炎。\nお話が苦手。\n語尾は「ノ」。\n会話の得意分野は歴史に関するうんちく。",
    "description_en": "Always shivering.\nExtremely timid.\nWhen angry, flames burst from the horn.\nNot good at talking.\nFavorite area of conversation is trivia about history.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "elephant",
    "stage": "adult",
    "player_level": 1,
    "tier": 2,
    "boost_type": "minigame-score",
    "encyclopedia_order": 406,
    "name_jp": "ぶるぶる科パオ属",
    "name_en": "pao",
    "description_jp": "常にぶるぶるしている。\n話が壮大になりがち。ダジャレ好き。\n語尾は「パオ」。\n会話の得意分野は古代の歴史うんちく。",
    "description_en": "Always shivering.\nTends to make stories grandiose.\nLoves puns.\nFavorite area of conversation is trivia about ancient history.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 200
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "lion",
    "stage": "adult",
    "player_level": 1,
    "tier": 2,
    "boost_type": "minigame-score",
    "encyclopedia_order": 407,
    "name_jp": "ぶるぶる科ライオン属",
    "name_en": "raion",
    "description_jp": "常にぶるぶるしている。\n強がりが激しいが、かなりの臆病者。\nたてがみが作り物だとバレるのを怖がる。\n語尾は「シ」。\n会話の得意分野はサバイバルとキャンプ。",
    "description_en": "Always shivering.\nAlways talks tough, but actually quite timid.\nAfraid the people will find out the mane is fake.\nFavorite area of conversation is trivia about survival and camping.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 200
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "reindeer",
    "stage": "adult",
    "player_level": 1,
    "tier": 2,
    "boost_type": "bpoint",
    "encyclopedia_order": 408,
    "name_jp": "ぶるぶる科トナカイ属",
    "name_en": "tonakai",
    "description_jp": "常にぶるぶるしている。\nサンタの手伝いで苦労した話をよくして、\nひとりため息で暗くなることがある。\n語尾は「トナ」。\n会話の得意分野はパーティー盛り上げうんちく。",
    "description_en": "Always shivering.\nOften talks about the hardship about helping Santa, and feels gloomy.\nFavorite area of conversation is trivia about how to enhance party.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "polarbear",
    "stage": "adult",
    "player_level": 1,
    "tier": 2,
    "boost_type": "bpoint",
    "encyclopedia_order": 409,
    "name_jp": "ぶるぶる科シロクマ属",
    "name_en": "shirokuma",
    "description_jp": "常にぶるぶるしている。\n前世の記憶で、水族館にいたことがある。\nよく前世の話をする不思議ちゃん。\n語尾は「ポラ」\n会話の得意分野は世界各国の水族館うんちく。",
    "description_en": "Always shivering.\nHas been in an aquarium in a past life memory.\nOften talks about the past life.\nFavorite area of conversation is trivia about aquarium from around the world.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "alpaca",
    "stage": "adult",
    "player_level": 1,
    "tier": 2,
    "boost_type": "bpoint",
    "encyclopedia_order": 410,
    "name_jp": "ぶるぶる科アルパカ属",
    "name_en": "arupaka",
    "description_jp": "常にぶるぶるしている。\nのんびりしている。\n語尾は「パカ」\n会話の得意分野はきれい好き＆掃除うんちく。",
    "description_en": "Always shivering.\nLaid back.\nFavorite area of conversation is trivia about aquarium from around cleaning.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "tiger",
    "stage": "adult",
    "player_level": 1,
    "tier": 3,
    "boost_type": "event-point",
    "encyclopedia_order": 411,
    "name_jp": "ぶるぶる科タイガ属",
    "name_en": "taiga",
    "description_jp": "常にぶるぶるしている。\n時々、大阪のおばちゃんみたいな口調が出る。\nノリツッコミやお笑いが好き。\n語尾は「トラ」。\n会話の得意分野は占いうんちく。",
    "description_en": "Always shivering.\nSomtimes talks like an old lady in Osaka.\nLikes to play a role of a comedian.\nFavorite area of conversation is trivia about fortune telling.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 200
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "sealion",
    "stage": "youth",
    "player_level": 1,
    "tier": 3,
    "boost_type": "event-point",
    "encyclopedia_order": 313,
    "name_jp": "ぶるぶる科アシカ属",
    "name_en": "ashika",
    "description_jp": "常にぶるぶるしている。\n地球でもみかんでもボールでも、\n丸いものに興味津々。\n人懐っこくて、親友になろうとしてくる。\n語尾は「ラシ」。\n会話の得意分野は人付き合いのコツうんちく。",
    "description_en": "Always shivering.\nInterested in anything round, whether it's the earth, oranges, or balls.\nFriendly and tries to be your friend.\nFavorite area of conversation is trivia about socializing.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "cow": 100,
      "dolphin": 100,
      "elephant": 50
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "flamingo",
    "stage": "adult",
    "player_level": 1,
    "tier": 3,
    "boost_type": "event-point",
    "encyclopedia_order": 412,
    "name_jp": "ぶるぶる科ミンゴ属",
    "name_en": "mingo",
    "description_jp": "常にぶるぶるしている。\nロマンチスト。上の顔のことが気になる。\n語尾は「ンゴ」。\n会話の得意分野は恋愛。",
    "description_en": "Always shivering.\nRomantic.\nAlways concerned about the face above.\nFavorite area of conversation is romance.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 200,
      "starball": 100
    }
  },
  {
    "id": "cow",
    "stage": "adult",
    "player_level": 1,
    "tier": 3,
    "boost_type": "event-point",
    "encyclopedia_order": 413,
    "name_jp": "ぶるぶる科モーモー属",
    "name_en": "mo-mo-",
    "description_jp": "常にぶるぶるしている。\nカフェに牛乳メニューを増やすのが夢。\n夢について語りかけてくる。\n語尾は「ウシ」。\n会話の得意分野は牛乳や乳製品うんちく。",
    "description_en": "Always shivering.\nDreaming to add more milk menu to the cafe.\nTalks to you about dream.\nFavorite area of conversation is trivia about milk and dairy products.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 200,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 200
    }
  },
  {
    "id": "persiancat",
    "stage": "youth",
    "player_level": 1,
    "tier": 3,
    "boost_type": "minigame-score",
    "encyclopedia_order": 314,
    "name_jp": "ぶるぶる科ペルシャ属",
    "name_en": "perusha",
    "description_jp": "常にぶるぶるしている。\nお嬢様でツンデレキャラ。\n語尾は「ペル」。\n会話の得意分野はギネス記録と高級なもの。",
    "description_en": "Always shivering.\nPrincess and tsundere character.\nFavorite area of conversation is Guinness world records and something expensive.",
    "stomach_sec": 102,
    "love_sec": 122,
    "dirtiness_sec": 180,
    "urine_sec": 216,
    "tooth_acidity_sec": 144,
    "scared_coefficient": 1.5,
    "next_weights": {
      "elephant": 100,
      "cow": 100,
      "dolphin": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 100
    }
  },
  {
    "id": "dolphin",
    "stage": "adult",
    "player_level": 1,
    "tier": 3,
    "boost_type": "minigame-score",
    "encyclopedia_order": 414,
    "name_jp": "ぶるぶる科イルカ属",
    "name_en": "iruka",
    "description_jp": "常にぶるぶるしている。\nパリピキャラ。\n語尾は「フィン」。\n会話の得意分野はリゾートやパーティのうんちく。",
    "description_en": "Always shivering.\nDie-hard party animal.\nFavorite area of conversation is resorts and party trivia.",
    "stomach_sec": 144,
    "love_sec": 172,
    "dirtiness_sec": 240,
    "urine_sec": 288,
    "tooth_acidity_sec": 180,
    "scared_coefficient": 1,
    "next_weights": {
      "ball": 100,
      "starball": 100
    },
    "reborn_weights": {
      "ball": 100,
      "starball": 100
    }
  }
]
